<template>
  <div class="mini-tab">
    <div class="mini-menu">
      <input placeholder="ミニロボ名" class="input is-small" style="border-radius: 0;" v-model="minibotName"/>
      <button class="button is-primary is-small" @click="createChatBotMini(chatbot)">ミニロボを作成する</button>
    </div>
    <div class="mini-menu">
      <input placeholder="🔍ミニロボ名検索" class="input is-small" v-model="searchMiniWord" @keydown.enter="searchMini()"/>
      <button class="button is-primary is-small" @click="searchMini()" :disabled="!searchMiniWord">検索</button>
    </div>
    <div v-if="isItemMasterPresence()" class="mini-menu">
      <!-- 媒体項目マスタープルダウン -->
      <select class="master-select" v-model="selectedMasterId" :disabled="!isLinkChangeable">
        <option
          v-for="(itemMaster, masterIndex) in getMediaCooperationItemMasterList()"
          :key="itemMaster.master_name + '_' + masterIndex"
          :value="itemMaster.id"
        >
          {{ itemMaster.master_name }}
        </option>
      </select>
      <!-- 紐付け/紐付け解除ボタン -->
      <button class="button is-primary is-small" @click="linkItemMaster()" :disabled="selectedMasterId === -1">{{isLinkStatus() ? '項目マスター解除' : '項目マスター紐付け'}}</button>
    </div>
    <div class="item-master-link" v-if="isLinkStatus()">※項目マスターに紐づけられている場合は、ミニロボ名の変更および削除はできません。</div>
    <div class="mini-beforeDestroy disp-scroll">
      <table class="mini-table">
        <tr class="mini-header">
          <th style="min-width: 64px; max-width: 64px;">項番</th>
          <th style="min-width: 90px; max-width: 90px;">アイコン</th>
          <th style="min-width: 150px; max-width: 150px;">名前</th>
          <th style="min-width: 100px; max-width: 100px;">プレビュー</th>
          <th style="min-width: 90px; max-width: 90px;">リンク</th>
          <th style="min-width: 100px; max-width: 100px;">削除</th>
        </tr>
        <tr class="mini-table-body" v-for="(mini, index) in showFilteredMini" :key="index">
          <td style="min-width: 64px; max-width: 64px;">{{index + 1}}</td>
          <td style="min-width: 90px; max-width: 90px;" @mouseover="roboIconHover = index" @mouseleave="roboIconHover = -1">
            <div style="position: relative;">
              <img @click="modalActive(true, mini.pk)" style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" :src="mini.icon_data" v-if="mini.icon_data"/>
              <img @click="modalActive(true, mini.pk)" style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" src="@/assets/template/robot.png" v-else>
              <div class="delete-button" @click="deleteIcon(mini.pk)" v-if="roboIconHover===index">×</div>
            </div>
          </td>
          <td style="min-width: 150px; max-width: 150px;">
            <input class="input is-small table-input" v-model="mini.name" @focus="storeCurrentName(mini)" @blur="updateChatBotMini(mini)" :disabled="isLinkStatus()"/>
          </td>
          <td style="min-width: 100px; max-width: 100px;">
            <a :href="makeLinkMini(chatbot.scenario_name, mini)" target="_blank" rel="noopener" class="button is-primary is-small"><span class="mdi mdi-play"></span></a>
          </td>
          <td style="min-width: 90px; max-width: 90px;">
            <button class="button is-small is-primary" @click="copySinglePageURLMini(chatbot, mini)"><span class="mdi mdi-link-variant"></span></button>
          </td>
          <td style="min-width: 100px; max-width: 100px;">
            <button class="button is-small is-danger" @click="deleteChatBotMini(mini)" :disabled="isLinkStatus()">削除</button>
          </td>
        </tr>
      </table>
    </div>
    <span v-if="isLoading" class="mdi mdi-loading mdi-spin mdi-48px"></span>
    <div v-if="chatbot.chatbot_mini.length == 0" style="text-align: center; margin-top: 8px;">
      ミニロボが設定されていません。
    </div>
  </div>
</template>

<script>
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  props: {
    chatbot: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * 媒体連携項目マスター一覧
     * @type {Array}
     */
    mediaCooperationItemMasterNameList: {
      type: Array,
      required: true,
    },
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      minibotName: null,
      roboIconHover: false,
      searchMiniWord: '',
      filteredMini: [],
      oldMiniPks: [],
      tempCurrentName: '',
      /**
       * 選択中媒体連携項目マスターID
       * @type {Number}
       */
      selectedMasterId: -1,
      /**
       * 選択中媒体連携項目マスター選択変更可能フラグ
       * @type {Boolean}
       */
      isLinkChangeable: false,
    }
  },
  computed: {
    showFilteredMini() {
      return this.isLoading ? [] : this.filteredMini
    }
  },
  watch: {
    // 紐づけ済み媒体連携項目マスター監視
    'chatbot.item_master' () {
      if (this.chatbot.item_master === null) {
        // 紐づけられた媒体連携項目マスターなし
        this.selectedMasterId = -1
        this.isLinkChangeable = true
      } else {
        // 媒体連携項目マスターが紐づけられている場合
        this.selectedMasterId = this.chatbot.item_master
        this.isLinkChangeable = false
      }
    },
    'chatbot.chatbot_mini' () {
      // 減った場合(削除)
      this.filteredMini = this.filteredMini.filter((item) => this.chatbot.chatbot_mini.map((item2) => item2.pk).includes(item.pk))
      // 増えた場合(作成)
      const added = this.chatbot.chatbot_mini.filter((item) => !this.oldMiniPks.includes(item.pk))
      this.filteredMini = this.filteredMini.concat(added.filter((item) => this.isMatchedSearchWord(item.name)))

      // 検索に合致しない名前で作成された場合は、検索をリセット
      if (added.some((item) => !this.isMatchedSearchWord(item.name))) {
        this.searchMiniWord = ''
        this.searchMini()
      }

      // 最新の状態に更新
      this.filteredMini = this.chatbot.chatbot_mini.filter((item) => this.filteredMini.map((item2) => item2.pk).includes(item.pk))

      this.oldMiniPks = this.chatbot.chatbot_mini.map((item) => item.pk)
    },
    searchMiniWord () {
      if (!this.searchMiniWord) this.searchMini()
    },
  },
  mounted () {
    this.searchMini()
    this.oldMiniPks = this.chatbot.chatbot_mini.map((item) => item.pk)
    // 紐付け済み媒体連携項目マスター選択
    if (this.chatbot.item_master === null) {
      // 紐付けされていない場合は初期表示にする
      this.selectedMasterId = -1
    } else {
      // 紐づけ済みの場合は設定されている媒体連携項目マスターのIDを設定する
      this.selectedMasterId = this.chatbot.item_master
    }
  },
  methods: {
    createChatBotMini (chatbot) {
      this.sendControlLogRelatedChatBot('ミニロボ作成', 'ミニロボ設定画面にて、ミニロボを新規に作成した。', chatbot)
      this.$emit('create-chatbot-mini', {
        name: this.minibotName,
        chatbot : chatbot
      })
      this.minibotName = null
    },
    storeCurrentName(mini) {
      this.tempCurrentName = mini.name
    },
    updateChatBotMini (mini) {
      this.sendControlLogRelatedChatBot('ミニロボ名変更', 'ミニロボ設定画面にて、ミニロボの名前を変更した。', this.chatbot)
      if (mini.name == '') {
        mini.name = this.tempCurrentName
        this.tempCurrentName = ''
      } else {
        this.$emit('update-chatbot-mini', mini)
      }
    },
    deleteChatBotMini (mini) {
      this.sendControlLogRelatedChatBot('ミニロボ削除', 'ミニロボ設定画面にて、ミニロボを削除した。', this.chatbot)
      this.$emit('delete-chatbot-mini', mini)
    },
    isMatchedSearchWord (word) {
      return word.toLowerCase().indexOf(this.searchMiniWord.toLowerCase()) != -1
    },
    searchMini () {
      this.filteredMini = this.chatbot.chatbot_mini.filter((item) => this.isMatchedSearchWord(item.name))
    },
    copySinglePageURLMini (chatbot, mini) {
      this.$emit('copy-singlepage-url-mini', {
        chatbot: chatbot,
        mini: mini
      })
    },
    makeLinkMini (name, mini) {
      return process.env.OWN_ENDPOINT + '/single/demo/' + this.chatbot.group + '/' + name + '/' + mini.pk
    },
    modalActive (isMini, pk) {
      const idx = this.chatbot.chatbot_mini.findIndex((item) => item.pk == pk)
      this.$emit('modal-active', {
        isMini: isMini,
        miniIdx: idx
      })
    },
    deleteIcon (pk) {
      const idx = this.chatbot.chatbot_mini.findIndex((item) => item.pk == pk)
      this.$emit('delete-icon', idx)
    },
    /**
     * 媒体連携項目マスター有無
     */
    isItemMasterPresence () {
      if (this.mediaCooperationItemMasterNameList.length > 0) {
        // 媒体連携項目マスターあり
        return true
      } else {
        // 媒体連携項目マスターなし
        return false
      }
    },
    /**
     * 媒体連携項目マスター一覧
     */
    getMediaCooperationItemMasterList () {
      // 初期表示データを差し込む
      let masterList = [{id: -1, master_name: "紐づける媒体連携項目マスターを選択してください。", is_working: true}]
      if (this.mediaCooperationItemMasterNameList.length > 0) {
        // 有効状態の媒体連携項目マスターを抽出してリストを追加する
        masterList = masterList.concat(this.mediaCooperationItemMasterNameList.filter(master => {return master.is_working === true}))
        return masterList
      } else {
        // 初期表示データのみ返す
        return masterList
      }
    },
    /**
     * 媒体連携項目マスター紐づけ状況取得
     */
    isLinkStatus () {
      if (this.chatbot.item_master === null) {
        // 紐づけられていない場合
        // 媒体連携項目マスターを選択可能状態にして、紐づけられるようにする
        this.isLinkChangeable = true
        // 紐づけられていない状態なのでfalseを返す
        return false
      } else {
        // 紐づけられている場合
        // 媒体連携項目マスターを選択不可状態にして、紐付け解除のみできるようにする
        this.isLinkChangeable = false
        // 紐づけられている状態なのでtrueを返す
        return true
      }
    },
    /**
     * 媒体連携項目マスター紐づけ保存
     */
    linkItemMaster () {
      if (this.isLinkChangeable === false) {
        // 選択不可状態の場合は解除処理
        this.chatbot.item_master = null
        this.selectedMasterId = -1
        this.isLinkChangeable = true
      } else {
        // 選択可能状態の場合は紐付け処理
        this.chatbot.item_master = this.selectedMasterId
      }
      // 親ロボの情報を更新
      this.$emit('updateChatBot', this.chatbot)
    },
  }
}
</script>

<style lang="scss" scoped>
.mini-tab {
  padding-top: 16px;
  .mini-menu {
    display: flex;
    margin: 8px;
    input {
      border-radius: 0;
    }
    button {
      min-width: 150px;
    }
    .master-select {
      width: calc(100% - 150px);
      border-radius: 0;
    }
  }
  .item-master-link {
    font-size: smaller;
    padding-bottom: 16px;
  }
  .mini-body {
    .mini-table {
      will-change: transform;
      margin: auto;
      .mini-header {
        display: table;
        th {
          padding: 4px;
          vertical-align: middle;
          text-align: center;
        }
      }
      .mini-table-body {
        display: table;
        text-align: center;
        max-height: 50px;
        min-height: 50px;
        height: 50px;
        td {
          padding: 4px;
          vertical-align: middle;
          text-align: center;
          input, button {
            margin: auto;
          }
          .table-input {
            border: dotted thin #ccc;
            background: transparent;
          }
        }
      }
    }
  }
}
.delete-button {
  position: absolute;
  top:    4px;
  right:  4px;
  height: 20px;
  width:  20px;
  border-radius: 50%;
  line-height: 0.95;
  border: solid thin #ccc;
  background: rgb(255, 255, 255);
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/MiniSettingMain.vue